// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var UrlHelpers = require("../UrlHelpers.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function fromQueryArgs(key) {
  var partial_arg = Curry._1(Relude_Option.flatMap, Relude_String.toNonWhitespace);
  var partial_arg$1 = UrlHelpers.QueryArgs.get(key);
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(partial_arg$1, Relude_List.head, param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
}

function fromQueryArgs$1(queryArgs) {
  return {
          campaign: fromQueryArgs("utm_campaign")(queryArgs),
          content: fromQueryArgs("utm_content")(queryArgs),
          medium: fromQueryArgs("utm_medium")(queryArgs),
          source: fromQueryArgs("utm_source")(queryArgs),
          term: fromQueryArgs("utm_term")(queryArgs)
        };
}

function toQueryArgs(param) {
  return Curry._1(UrlHelpers.QueryArgs.fromList, Relude_List.mapOption((function (param) {
                    var key = param[0];
                    return Relude_Option.map((function (value) {
                                  return [
                                          key,
                                          value
                                        ];
                                }), param[1]);
                  }), {
                  hd: [
                    "utm_campaign",
                    param.campaign
                  ],
                  tl: {
                    hd: [
                      "utm_content",
                      param.content
                    ],
                    tl: {
                      hd: [
                        "utm_medium",
                        param.medium
                      ],
                      tl: {
                        hd: [
                          "utm_source",
                          param.source
                        ],
                        tl: {
                          hd: [
                            "utm_term",
                            param.term
                          ],
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }));
}

var empty = {
  campaign: undefined,
  content: undefined,
  medium: undefined,
  source: undefined,
  term: undefined
};

exports.fromQueryArgs = fromQueryArgs$1;
exports.toQueryArgs = toQueryArgs;
exports.empty = empty;
/* UrlHelpers Not a pure module */
